module.exports = __webpack_public_path__ + "assets/img/37_1048.8ba627a2.jpg";